export default "__VITE_ASSET__Db7N3g6h__"